module.exports = __webpack_public_path__ + "static/media/goldenGate.f1875a0d.jpg";